var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-view',{attrs:{"header":_vm.header,"items":_vm.model.citizenships},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('span',[_vm._v(_vm._s(item.country_name))])])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }